import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import apiClient from '../../../../../../api/apiClient';
import { usePreloaderStore } from '../../../../../../stores';
import { Endpoints, Defaults } from '../../../../../../views/democracy/constants';
import {
    valueToMediaRefs, buildMultipartRequest, extractErrorMessage
} from '../../../../../../views/democracy/utils';
import AppMedia from '../../../controls/media/AppMedia';
import Modal from '../../../controls/Modal';
import LabeledInput from '../../../controls/LabeledInput';
import HmsInput from '../../../controls/HmsInput';

// Модалка редактирования раунда (медиа-обложка — переиспользуемый виджет CustomMedia).
export default function RoundEditModal({ round, onChanged, onClose }) {
    const { enqueueSnackbar } = useSnackbar();
    const { show, hide } = usePreloaderStore();
    const [data, setData] = useState({
        orderId: round.orderId,
        title: round.title || '',
        timeBudgetSeconds: round.timeBudgetSeconds ?? Defaults.timeBudgetSeconds,
        description: round.description || '',
        coverMedia: round.coverMedia || null
    });
    const [coverPendingFile, setCoverPendingFile] = useState(null);

    const setField = (field, value) => setData(prev => ({ ...prev, [field]: value }));

    const handleSave = async () => {
        show();
        try {
            const coverList = data.coverMedia ? [data.coverMedia] : [];
            const payload = {
                orderId: parseInt(data.orderId, 10),
                title: data.title,
                description: data.description || null,
                timeBudgetSeconds: parseInt(data.timeBudgetSeconds, 10) || Defaults.timeBudgetSeconds,
                coverMedia: valueToMediaRefs(coverList)
            };
            const formData = buildMultipartRequest(payload, coverPendingFile ? [coverPendingFile] : []);
            await apiClient.put(Endpoints.rounds.update(round.id), formData);
            enqueueSnackbar('Сохранено', { variant: 'success' });
            onChanged();
            onClose();
        } catch (error) {
            enqueueSnackbar(extractErrorMessage(error, 'Не удалось сохранить раунд'), { variant: 'error' });
        } finally {
            hide();
        }
    };

    const footer = (
        <>
            <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
            <button type="button" className="btn btn-primary" onClick={handleSave}>Сохранить</button>
        </>
    );

    return (
        <Modal open title="Редактирование раунда" onClose={onClose} footer={footer}>
            <LabeledInput label="Номер" value={String(data.orderId)} onChange={(e) => setField('orderId', e.target.value)} />
            <LabeledInput label="Название" value={data.title} onChange={(e) => setField('title', e.target.value)} />
            <HmsInput label="Бюджет времени" seconds={data.timeBudgetSeconds}
                onChange={(secs) => setField('timeBudgetSeconds', secs)} />
            <div>
                <label className="ctl-label">Обложка</label>
                <AppMedia
                    value={data.coverMedia}
                    pendingFile={coverPendingFile}
                    onChange={(nextValue, nextPending) => { setField('coverMedia', nextValue); setCoverPendingFile(nextPending); }}
                    type="IMAGE"
                />
            </div>
            <div>
                <label className="ctl-label">Описание</label>
                <textarea className="textarea" value={data.description} onChange={(e) => setField('description', e.target.value)} />
            </div>
        </Modal>
    );
}

RoundEditModal.propTypes = {
    round: PropTypes.shape({
        id: PropTypes.number.isRequired,
        orderId: PropTypes.number,
        title: PropTypes.string,
        description: PropTypes.string,
        timeBudgetSeconds: PropTypes.number,
        coverMedia: PropTypes.object
    }).isRequired,
    onChanged: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
